var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-entrance" },
    [
      _c(
        "el-tooltip",
        { attrs: { content: "我的任务", placement: "bottom" } },
        [
          _c(
            "div",
            {
              staticClass: "message-entrance-item",
              on: {
                click: function($event) {
                  return _vm.goMessageAgent("task")
                }
              }
            },
            [
              _c(
                "el-badge",
                {
                  attrs: { value: _vm.$store.getters.todoUpdateEvent, max: 99 }
                },
                [
                  _c("img", {
                    staticClass: "message-entrance-img",
                    attrs: { src: require("../../assets/ic_agent.png") }
                  })
                ]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-tooltip",
        { attrs: { content: "消息通知", placement: "bottom" } },
        [
          _c(
            "div",
            {
              staticClass: "message-entrance-item",
              on: {
                click: function($event) {
                  return _vm.goMessageAgent("message")
                }
              }
            },
            [
              _c(
                "el-badge",
                {
                  attrs: {
                    value: _vm.$store.getters.messageUpdateEvent,
                    max: 99
                  }
                },
                [
                  _c("img", {
                    staticClass: "message-entrance-img",
                    attrs: { src: require("../../assets/ic_notification.png") }
                  })
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }